import { useLang } from "../i18n/i18n";

export default function Logo({ compact = false }) {
  const { t } = useLang();
  return (
    <span className="flex items-center gap-3 select-none" data-testid="brand-logo">
      <svg width="38" height="38" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect x="1.5" y="1.5" width="61" height="61" rx="13" stroke="#D4AF37" strokeOpacity="0.55" strokeWidth="1.5" />
        <rect x="17" y="10" width="30" height="44" rx="6" stroke="#D4AF37" strokeWidth="2" fill="rgba(212,175,55,0.07)" />
        <rect x="22" y="15" width="20" height="10" rx="2" fill="#F0D68A" />
        <circle cx="23.5" cy="32" r="2.4" fill="#D4AF37" />
        <circle cx="32" cy="32" r="2.4" fill="#D4AF37" />
        <circle cx="40.5" cy="32" r="2.4" fill="#D4AF37" />
        <circle cx="23.5" cy="40" r="2.4" fill="#D4AF37" />
        <circle cx="32" cy="40" r="2.4" fill="#D4AF37" />
        <circle cx="40.5" cy="40" r="2.4" fill="#D4AF37" />
        <circle cx="23.5" cy="48" r="2.4" fill="#D4AF37" />
        <circle cx="32" cy="48" r="2.4" fill="#D4AF37" />
        <rect x="36.5" y="45.6" width="8" height="4.8" rx="2.4" fill="#F0D68A" />
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className="block font-display text-[15px] tracking-[0.18em] text-goldlight uppercase">InstaGold Calc</span>
          <span className="block mt-1 text-[10px] tracking-[0.32em] text-mutedc uppercase" data-testid="brand-tagline">
            {t("logo.tagline")}
          </span>
        </span>
      )}
    </span>
  );
}
